export const RULE_LABELS: Record<string, string> = {
  late_bypass: "Bypass Late",
  early_departure_bypass: "Bypass Early Departure",
  treat_as_holiday: "Treat as Holiday",
  ignore_sl_hd: "Ignore SL / HD",
  wfh: "Work From Home",
};

export const WEEKDAY_LABELS = [
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat",
];

export interface EmployeeLite {
  id: number;
  name: string;
  image: string;
}

export const buildEmployeeMap = (employees: any[]) => {
  const map = new Map<number, EmployeeLite>();
  (Array.isArray(employees) ? employees : []).forEach((e) => {
    const id = Number(e.id);
    map.set(id, {
      id,
      name:
        `${e.fname || ""} ${e.lname || ""}`.trim() ||
        e.username ||
        `Employee-${id}`,
      image: e.profile_pic || "",
    });
  });
  return map;
};

export const buildDepartmentMap = (departments: any[]) => {
  const map = new Map<number, string>();
  (Array.isArray(departments) ? departments : []).forEach((d) => {
    map.set(Number(d.value), d.label);
  });
  return map;
};

export interface GroupedException {
  dates: string[];
  rules: string[];
  remarks: string;
  applies_to: {
    type: string;
    department_ids: number[];
    employee_ids: number[];
  };
}

export const groupHistoryExceptions = (
  exceptions: any[],
): GroupedException[] => {
  const groups = new Map<string, GroupedException>();
  (Array.isArray(exceptions) ? exceptions : []).forEach((ex) => {
    const rules = [...(ex.rules || [])].sort();
    const at = ex.applies_to || {
      type: "all",
      department_ids: [],
      employee_ids: [],
    };
    const key = JSON.stringify({
      r: rules,
      t: at.type,
      d: [...(at.department_ids || [])].sort(),
      e: [...(at.employee_ids || [])].sort(),
      m: ex.remarks || "",
    });
    const existing = groups.get(key);
    if (existing) {
      existing.dates.push(ex.date);
    } else {
      groups.set(key, {
        dates: [ex.date],
        rules,
        remarks: ex.remarks || "",
        applies_to: {
          type: at.type || "all",
          department_ids: at.department_ids || [],
          employee_ids: at.employee_ids || [],
        },
      });
    }
  });
  return Array.from(groups.values()).map((g) => ({
    ...g,
    dates: [...g.dates].sort(),
  }));
};
